import React from 'react';

const RoundBracketClose = () => (
    <>
        <span className="round-bracket">)</span>
    </>
);

export default RoundBracketClose;
